import { CODE_MASTER, DivisionDict } from "../default-constants";

// 加盟店申請（直接） 事業者情報のラベル
export const LABELS = {
  TITLE: "事業者情報確認・更新",
  RATE_TITLE: "料率内容確認・更新",
  FEE_RATE: "手数料率",
  RATE_INFO: "手数料率を登録願います。",
  RATE_UPDATE: "　　登録　　",
  BACK: "　　戻る　　",
  FEE_RATE_UPDATE: "料率（%）",

  FORM_TITLE: "申請事業者情報",

  CONTRACT_STYLE: "契約形態",
  CONTRACT: "契約",
  COMPANY_CODE: "事業者コード",
  CORP_NAME: "事業者名",
  CORP_KANA: "事業者名カナ",
  CORP_ENG: "事業者名英字",
  ADDRESS: "本社住所",
  TEL: "電話番号",
  TEL_DETAIL: "（電話番号（明細表示用））",
  HEAD_OFFICE_TEL: "本社電話番号",
  REGISTERED_COMPANY: "登録事業者",
  LICENSE_INFORMATION: "許認可証情報",

  MERCHANT_TABLE: "加盟店一覧",
  MERCHANT_CHECKBOX: "検証サイトIDを表示する",

  ALL: "ALL",
  CONTRACT_DIRECTLY: "直接",
  CONTRACT_COMPREHENSIVE: "包括",

  CREATE_DATE: "登録日",
  STATUS: "ステータス",
  SERVICE: "サービス",
  CONTRACT_ROUTE: "契約ルート",
  MERCHANT_NAME: "加盟店名",
  CHARGE: "課金",
  PAYMENT_METHOD: "QR提示区分",
  SITE_ID: "サイトID",
  GW_COMPANY: "ゲートウェイ",
  D_POINT_SITE_ID: "サイトID（dポイント）",
  SHOPID: "ショップID",
  RATE: "料率",
  CORP_CODE: "企業コード",
  STORE_CODE: "店舗コード",
  STORE_NAME: "店舗名",
  STORE_NAME_DETAIL: "店舗名（明細表示用）",
  STORE_ADDRESS_DETAIL: "店舗住所",
  STORE_TABLE: "店舗一覧",

  APPLICATION_INFO_TITLE: "申請事業者情報",

  CORP_NUMBER: "法人番号",
  DUN_NUMBER: "DUNSナンバー",
  COMPANY_STYLE: "事業形態",
  COMPANY_TYPE: "法人格",
  CORP_NAME_DETAIL: "事業者名（明細表示用）",
  URL: "ホームページURL",
  FOUNDATION_DATE: "設立年月",
  CAPITAL: "資本金",
  EMPLOYEE_NUMBER: "従業員数",

  REP_INFO_TITLE: "代表者情報",

  REP_NAME: "代表者名",
  REP_KANA: "代表者名カナ",
  REP_ENG: "代表者名英字",
  BIRTHDAY: "代表者生年月日",
  COUNTRY: "代表者居住国",

  GROUP_TABLE_TITLE: "参照グループ",

  GROUP_ID: "グループID",
  GROUP_NAME: "グループ名",

  TSR_INFO_TITLE: "TSR調査内容",

  COMPANY_SITUATION: "会社状況",
  POINT: "評点",

  MEMORANDUM_INFO_TITLE: "覚書管理",

  UPLOAD_TABLE_TITLE: "アップロード済ファイル",

  FILE_NAME: "ファイル名",
  UPLOADED_BY: "アップロード者",
  UPLOADED_AT: "更新日",
  COMMENT: "コメント",

  ACCESS_TITLE: "接続試験結果エビデンス",

  INCLUSION_MERCHANT: "包括加盟店名",

  MERCHANT_TITLE: "加盟店情報",

  ITEM: "表示項目選択",

  PAYMENT_TITLE: "支払方法関連",
  CREDIT: "クレジット払い",
  D_PAYMENT: "dカード払い",
  D_POINT: "dポイント充当",
  INVOICE: "請求書合算払い",
  PREALLOCATION: "クーポン充当",
  D_PAYMENT_BALANCE: "d払い残高からのお支払い",
  REFUSAL: "拒否対象ブランド",
  USAGE: "利用可能バリュー区分",

  VISA: "VISA",
  MASTER: "MASTER",
  JCB: "JCB",
  AMEX: "AMEX",
  DINERS_CLUB: "Diners Club",

  CASH: "現金バリュー",
  PREPAY: "プリペイドバリュー",

  PAYMENT_CONTROL_TITLE: "支払制御関連",

  SETTLEMENT_LIMIT_PRM: "決済上限金額（PRM）",
  SETTLEMENT_LIMIT: "決済上限金額",

  CREDIT_PATTERN_TITLE: "与信パターン",

  BILL_COMBINED_PAYMENT: "請求書合算払い",
  CONTINUATION: "継続",
  PAY_WITH_D_PAYMENT: "d払い残高からのお支払い",
  D_CARD: "dカード払い",
  CREDIT_PAYMENT: "クレジット払い",

  SYSTEM_TITLE: "システム項目関連",

  USAGE_TYPE: "利用種別",
  COMMERCIAL: "商用",
  NOT_COMMERCIAL: "検証用",
  NOT_SUBJECT_TO_PAYMENT: "精算対象外フラグ",
  MATCHING: "突合可能期限",

  D_POINT_PRESENTATION_TITLE: "dポイント進呈",
  D_POINT_PRESENTATION: "dポイント進呈",
  POINT_STANDARD: "ポイント進呈基準金額",
  POINT_PRESENTATION: "ポイント進呈数",
  YEN_UNIT: "円",
  POINT_UNIT: "ポイント",

  SITE_ID_TITLE: "サイトID",

  CONTENTS_CHECK_TITLE: "コンテンツチェックシート",

  LAST_UPDATER: "最終更新者:",
  LAST_UPDATING_TIME: "最終更新日時:",

  APPLICATION_INQUIRY: "申請内容紹介",
  APPLICATION_NO: "申請No",
  APPLICATION_STATUS: "申請状況",
  APPLICATION_MANAGER: "申請担当",
  FILING_DATE: "申請日",
  APPLICATION_TYPE: "申請種別",
  INDIVIDUAL_HANDLING_STATUTE_OF_LIMITATIONS: "個別取扱事項",
  CONTRACT_DOCUMENT: "契約書",
  PROPOSAL: "提案書",
  NUMBER_OF_STORES_TENANTS: "店舗・テナント数",
  RATE_NOTICE: "料率通知書",
  BUSINESS_PERSON: "事業者　　　　　　　",
  BUSINESS_FORM: "事業形態　　　　　　",
  CORPORATE_NUMBER: "法人番号",
  REPRESENTATIVE: "代表者　　　　　　　",
  MERCHANT_CATEGORY: "加盟店カテゴリ　　　",

  MERCHANT_NAME_KANA: "加盟店名カナ",
  MERCHANT_NAME_ENG: "加盟店名英字",

  DETAIL_MERCHANT_TITLE: "加盟店情報",
  DETAIL_STORE_TITLE: "店舗情報",
  MODAL_TITLE: "加盟店情報照会（加盟店詳細）",
  MODAL_STORE_TITLE: "加盟店情報照会（店舗情報詳細）",
  MERCHANT_TYPE: "加盟店種別　　　",
  STORE_ADDRESS: "商業施設住所",
  COMMERCIAL_FACILITY_PHONE_NUMBER: "商業施設電話番号",
  EARNING: "売上高",
  BILLION_YEN: "億円",
  YEAR: "年",
  INDUSTRY: "業態",
  INDUSTRY_COMMENT: "業態補足",
  IPID: "IPID　　　　　　",
  SHOP_ID: "ショップID",
  SHOP_PW: "ショップパスワード",
  MERCHANT_ID: "加盟店管理番号　",
  MERCHANT_LABEL: "（包括加盟店）",
  CONTRACT_TITLE: "契約内容",
  GW: "GW",
  TERMINATION_DATE: "解約希望日　　　　",
  TERMINATION_LABEL: "（決済停止日）",
  CHANGED_APP: "変更申請あり",
  ADAPTED_DAY: "適用反映日",
  START_DATE: "開始日",
  END_DATE: "終了日",
  BUTTON_LABEL_RATE: "　料率変更　　",
  BUTTON_LABEL_CHANGE_DETAIL: "加盟店情報変更",
  POSTED_MAP: "地図掲載",
  CLOSE: "閉じる",
  BLANK: "　",
  INFORMATION_CHANGE: "事業者情報変更",
  TERMINAL_IDENTIFICATION_NUMBER: "端末識別番号　　",
  ADDRESS_DETAILS_NOT_OTHER: "　　　詳細　　　",
  ADDRESS_DETAILS_OTHER: "詳細（他住所あり）",
  APPLICATION_COMPANY_SUB_TITLE:
    "契約ルートごとに異なる事業者住所が登録されています",
  DIRECT_CONTRACT: "直接契約",
  REGISTERED_COMPANY_CORPORATE_NUMBER: "登録事業者 法人番号",
  REGISTERED_COMPANY_COMPANY_NAME: "登録事業者名",
  DETAIL_SEARCH: "詳細検索",
  // Orange項目追加
  //  決済グループID
  SETTLEMENT_GROUP_ID: "決済グループID",
  //  Access Key
  ACCESS_KEY: "Access Key",
  //  Secret Key
  SECRET_KEY: "Secret Key",

  // 入力許可文字
  HALF_WIDTH_ALPHANUMERIC: "半角英数字",

  //文字数
  MERCHANT_NAME_LEN: 100,
  SITE_ID_LEN: 13,
  STORE_NAME_LEN: 100,
  SHOP_CODE_LEN: 20,
  BUSINESS_CODE_LEN: 20,
  REGISTERED_COMPANY_CORPORATE_NUMBER_LEN: 13,
  REGISTERED_COMPANY_COMPANY_NAME_LEN: 30,

  // 表示数
  ADDRESS_SHOW_LEN: 2,

  // 注釈文言
  CONSTRAINT_TEXT_DIGITS: "桁以内",
  SEARCH_ANNOTATION_MESSAGE: "条件を指定して検索ボタンを押して下さい",

  // レイアウト余白
  BLANK_SPACE_ONE: "　",
  BLANK_SPACE_TWO: "　　",
  BLANK_SPACE_FIVE: "　　　　　",
  SLASH: "　/　",
} as const;
// SELECTの空行の定義
export const SELECT_BLANK = { label: "　", value: "" };
// 契約ルート
const CONTRACT_ALL = "00";
export const CONTRACT_DIRECTLY = "1";
export const CONTRACT_COMPREHENSIVE = "2";
export const CONTRACT_ROUTE_SELECT_ITEMS: DivisionDict[] = [
  {
    value: CONTRACT_ALL,
    label: LABELS.ALL,
  },
  {
    value: CONTRACT_DIRECTLY,
    label: LABELS.CONTRACT_DIRECTLY,
  },
  {
    value: CONTRACT_COMPREHENSIVE,
    label: LABELS.CONTRACT_COMPREHENSIVE,
  },
];

// システム設定表示項目
export const DISPLAY_OPTIONS: DivisionDict[] = [
  { value: "1", label: "全項目" },
  { value: "2", label: "支払方法関連" },
  { value: "3", label: "支払制御関連" },
  { value: "4", label: "与信パターン" },
  { value: "5", label: "システム項目関連" },
  { value: "6", label: "dポイント進呈" },
];
// 有効無効
export const ENABLED_VALUE = "1";
export const DISABLED_VALUE = "0";
export const ENABLED_DISABLED_OPTIONS: DivisionDict[] = [
  { value: ENABLED_VALUE, label: "有効" },
  { value: DISABLED_VALUE, label: "無効" },
];
// 利用種別
export const USAGE_TYPE_OPTIONS = [
  { value: "0", label: "商用" },
  { value: "1", label: "検証用" },
];
// 請求書合算払い
export const BILLING_OPTIONS = [
  { value: "R2", label: "パターンR2" },
  { value: "81", label: "パターン3A" },
  { value: "82", label: "パターン82" },
];
// d払い残高からのお支払い
export const D_BALANCE_PAYMENT_OPTIONS = [
  { value: "85", label: "パターン4A（d払い残高からのお支払い）" },
  { value: "8U", label: "パターン8U（サイトID別限度額有り）" },
  { value: "9C", label: "パターン4A（d払い残高からのお支払い）（マイナNG用）" },
];
//旧与信パターンで異動情報連携されるとMobillsで他クレ支払いについて決済障害が発生する可能性があるため、バーコードについては旧与信パターンの蓋閉じを実施
// dカード払い
export const D_CARD_PAYMENT_OPTIONS = [
  { value: "A1", label: "パターンA1" },
  { value: "CD", label: "パターンCD（サイトID別限度額有り）" },
];
// クレジット払い
export const CREDIT_PAYMENT_OPTIONS = [
  { value: "CM", label: "パターンCM（クレジット限度額有）" },
  { value: "CP", label: "パターンCP（サイトID別限度額有り）" },
];
// 利用可能バリュー区分
interface IEnableValue {
  all: DivisionDict;
  cashValue: DivisionDict;
  prepaidValue: DivisionDict;
}
export const ENABLE_VALUE: IEnableValue = {
  all: {
    value: "0",
    label: "すべて",
  },
  cashValue: {
    value: "1",
    label: LABELS.CASH,
  },
  prepaidValue: {
    value: "2",
    label: LABELS.PREPAY,
  },
};
// 突合可能期限
interface IReconcilablePeriod {
  endOfNextNextMonth: DivisionDict;
  ninetyDaysLater: DivisionDict;
  oneYear: DivisionDict;
}
export const RECONCILABLE_PERIOD: IReconcilablePeriod = {
  endOfNextNextMonth: {
    value: "1",
    label: "翌々月末",
  },
  ninetyDaysLater: {
    value: "2",
    label: "90日後",
  },
  oneYear: {
    value: "4",
    label: "367日",
  },
};

// 住所種別
const CONFIRMATION_ADDRESS = CODE_MASTER["CONFIRMATION_ADDRESS"];
export const ADDRESS_TSR = CONFIRMATION_ADDRESS[1];
export const ADDRESS_TAX = CONFIRMATION_ADDRESS[2];
export const ADDRESS_APP = CONFIRMATION_ADDRESS[3];
export const ADDRESS_OTHER_LABEL = "その他";
